{
  "WALLBOARD": {
    "LOADING": "Laster telefonkøer...",
    "NO_QUEUES": "Ingen telefonkøer funnet.",
    "NO_AGENTS": "Ingen agenter er pålogget i denne køen.",
    "UNKNOWN_CALLER": "Ukjent innringer",
    "STATUS": "Status",
    "TIME": "Tid",
    "AGENT": "Agent",
    "EXTENSION": "Internnummer",
    "READY": "Klare agenter",
    "ON_CALL": "Agenter i samtale",
    "PAUSED": "Agenter i pause",
    "WAITING": "Ventende anrop",
    "MISSED_CALLS": "Tapte anrop",
    "HANDLED_CALLS": "Behandlede innkommende anrop",
    "OUTBOUND_CALLS": "Behandlede utgående anrop",
    "AVAILABILITY": "Tilgjengelighet",
    "AVAILABILITY_TOOLTIP": "Prosentandel innkommende anrop besvart av agenter (anrop som ble tatt opp)",
    "AGENTS_COUNT": "({onCall} i samtale / {total} totalt)",
    "NO_AVAILABLE": "(ingen pålogget)",
    "WAITING_CALLERS_COUNT": "{count} venter",
    "CALLER": "Innringer",
    "NUMBER": "Nummer",
    "WAIT_TIME": "Ventetid",
    "ACTION": "Handling",
    "PICKUP_CALL": "Ta opp",
    "PICKUP_SUCCESS": "Forespørsel om å ta opp anropet er sendt.",
    "PICKUP_ERROR": "Kunne ikke ta opp anropet. Prøv igjen.",
    "PICKUP_DISABLED_TOOLTIP": "Du kan ikke ta opp et anrop mens du er i en samtale eller frakoblet.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Ingen tilgang"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Ingen tilgang"
    }
  }
}
